<template>
  <div style="height: 100%;">
    <div class="domain-container">
      <div :style="{'height':'100%', 'margin': 'auto' }">
        <a :href="data.classesUrls[0].url" target="_blank">
          <div class="cashier">
            <div class="cashier-img" >
              <img v-if="data.classesProp==2" :src="`${assetsUrl}imgs/cashier.png`">
              <img v-if="data.classesProp==3" :src="`${assetsUrl}imgs/xsqy.png`">
              <img v-if="data.classesProp==5" :src="`${assetsUrl}imgs/course/sxgc.png`">
              <img v-if="data.classesProp==6" :src="`${assetsUrl}imgs/course/renzheng.png`">
              <div class="area" v-if="domainData.typeName">当前学习的报税区域:<span>{{ domainData.typeName }}</span></div>
            </div>
            <div class="intro">
              <div v-if="data.classesProp==2" class="case">
                <h3>会计新手</h3>
                <ul class="freshman">
                  <li>出纳</li>
                  <li>新设企业账税一体化（小规模）</li>
                </ul>
                <p>
                  采用任务驱动式学习方法，学会出纳日常工作内容，熟悉三大网银操作步骤，掌握新设企业注册登记流程及开办期间业务，能够独立完成小规模纳税人的报税内容。
                </p>
                <a class="enter-btn">
                  <button>进入学习</button>
                </a>
              </div>
              <div v-if="data.classesProp==3" class="case">
                <h3>会计精英</h3>
                <ul class="elite ">
                  <li>手工全盘账</li>
                  <li>电算化全盘账</li>
                  <li>工业全盘账</li>
                  <li>纳税</li>
                </ul>
                <p>
                  全面掌握会计上岗所必备的知识与技能，完成不同难度和不同业态环境下的账务处理，掌握电算化系统的操作，能够进行日常的开票、发票管理、国地税及个税的申报工作。
                </p>
                <a class="enter-btn">
                  <button>进入学习</button>
                </a>
              </div>
              <div v-if="data.classesProp==5" class="case">
                <h3>APOIT会计实习工厂</h3>
                <ul class="elite  ">
                  <li>人工智能时代 重新定义会计</li>
                  <!--<li style="width: 30%;">事业单位</li>
                <li style="width: 30%;">酒店餐饮</li>
                <li style="width: 30%;">金融投资</li>
                <li style="width: 30%;">建筑施工</li>
                <li style="width: 30%;">生活服务</li>
                <li style="width: 30%;">工业生产</li>
                <li style="width: 30%;">房产置业</li>
                <li style="width: 30%;">商业贸易</li>
                <li style="width: 30%;">对外贸易</li>
                <li style="width: 30%;">农林渔业</li>
                <li style="width: 30%;">街道社区</li>-->
                </ul>
                <p>
                  <!-- 人工智能时代 重新定义会计-->
                  事业单位 酒店餐饮 金融投资 建筑施工 生活服务 工业生产 房产置业 商业贸易 对外贸易 农林渔业 街道社区...
                </p>
                <a class="enter-btn">
                  <button>进入学习</button>
                </a>
              </div>
              <div v-if="data.classesProp==6" class="case">
                <h3>会计信息化证认证课程</h3>
                <ul class="elite ">
                  <li>出纳</li>
                  <li style="width: 56%">新设企业账税一体化（小规模）</li>
                  <li>手工全盘账</li>
                  <li>电算化全盘账</li>
                  <li>工业全盘账</li>
                  <li>纳税</li>
                </ul>
                <a class="enter-btn">
                  <button>进入学习</button>
                </a>
              </div>
              <!--<div *ngSwitchDefault=""><img :src="{{assetsUrl}}imgs/course/staleDated.png"></div>-->
            </div>
          </div>
        </a>
        <!-- <div v-if="domainData.courseId == 5" class="sxgc-content" id="sxgc-content">
          <sxgc-acc :url="nextUrl"></sxgc-acc>
        </div> -->
      </div>

    </div>
    <div id="noClasses"
         style="width: 100%;height: 100%;position: relative;display:none">
      <div style="height: 10rem;width:10rem;position: absolute;  left: 0;  right: 0; margin: auto; top: 0;  bottom: 0;">
        <img style="width:10rem;" :src="`${assetsUrl}imgs/course/renzheng.png`">
        <span class="error-mess">{{ errorMess }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { authServerCostAcc } from '@/api/myAddition'
import sxgcAcc from './sxgc-acc/index.vue'
export default {
  name: 'Mock',
  components: {
    sxgcAcc
  },
  props: {
  planclassesId: {
      type: String,
      required: false,
      default: ''
    },
    classesId: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
    assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
    para: {
    },
    domain: '1',
    domainData: { courseId: 5 },
    info: '1',
    nextUrl: '1',
    errorMess: '1',
    }
  },
  created() {
    console.log(this.data)
    this.para = {
      classesId: this.classesId,
      planclassesId: this.planclassesId
    }
    // this.loadCostAcc()
  },
  methods: {
    goClass(data) {
      window.location.href = data.classesUrls[0].url
    },
  // chose(obj) {
  //   this.dialogService.confirm({
  //     title: '选择确认',
  //     content: '您的学习将配套<i>' + obj.name + '</i> 当地的财税政策，一旦确定则无法更改，请确认您的选择! ',
  //     html: true,
  //     yes: '确定', //
  //     no: '取消',
  //   })
  //     .subscribe(
  //       data => {
  //         this.http.postHttpWithH('studentWebApi.html?authServerCostAcc', {
  //           domain: obj.code,
  //           classesId: this.classesId,
  //           planclassesId: this.planclassesId
  //         }).subscribe(
  //           result => {
  //             if (result.state === 1) {
  //               this.init()
  //             } else {
  //               document.getElementById('noClasses').style.display = 'block'
  //             }
  //           }

  //         )
  //       },
  //       // error => console.error('Rebirth confirm get no result:', 133222)
  //     )
  // },
  loadCostAcc() {
    authServerCostAcc(this.para).then(
      (result) => {
        this.domainData = result
        if (result.state === 1) {
          if (result.next_url) {
            this.nextUrl = result.next_url
            this.domain = null
          } else {
            this.domain = result.list
            if (result.list.length === 1) {
              // this.chose()
              authServerCostAcc(
                {
                  domain: result.list[0].code,
                  classesId: this.classesId,
                  planclassesId: this.planclassesId
                }
              ).then(
                result => {
                  if (result.state === 1) {
                    this.init()
                  } else {
                    document.getElementById('noClasses').style.display = 'block'
                  }
                }
              )
              this.domain = null
            }
          }
        } else {
          document.getElementById('noClasses').style.display = 'block'
          this.errorMess = result.mess
        }
      }
    )
  },

  postDomain() {
    const params = {
      accreditKey: this.domainData.accreditKey,
      courseId: this.domainData.courseId,
      domain: this.domainData.domain,
      orgId: this.domainData.orgId,
      sign: this.domainData.sign,
      uuid: this.domainData.uuid,
      ts: this.domainData.ts,
    //   url: LocalStorageUtil.getInstance().costAcc + 'api.html?authService'
    }
    this.http.postHttpWithH('studentWebApi.html?authService', params).subscribe(
      result => {
        this.http.alertMsg('错误代码', this.errorMess)
        const data = result.data
        this.info = result.info
        if (data.returnCode === '00') {
          this.nextUrl = data.next_url
          this.domain = null
        } else {
          this.http.alertMsg('错误代码', data.returnCode)
        }
      }
    )
  }
  },
}
</script>
<style scoped lang="less">
a{
  text-decoration: none;
}
.domain-container{
  position: relative;
  width: 100%;
  height: 100%;
}
.error-mess{
  color: #8fb0d4;
  font-family:”Microsoft YaHei”;
  text-align: center;
  width: 100%;
  display: block;
  font-weight: bold;
  font-size: 1.3rem;
}

.cashier{
  width: 49.8rem;
  height: 16rem;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top:0;
  bottom: 0;
  background-color: #188eee;
  box-shadow: 0 0 0.5rem #999;
}
.cashier-img{
  position: relative;
  width: 22.4rem;
  float: left;
}
.cashier-img img{
  width: 100%;
}
.area{
  position: absolute;
  bottom: 1.2rem;
  left: 0;
  right: 0;
  font-size: .8rem;
  font-weight: 700;
  color: #fff;
  text-align: center;
}
.area span{
  color: #fffc00;
}
.intro{
  height: 16rem;
  overflow: hidden;
  background-color: #ffffff;
}
.case h3{
  font-size: 1.2rem;
  text-align: center;
  color: #000;
  font-weight: 700;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.elite{
  margin: 0 auto;
  overflow: hidden;
  padding-left: 1rem;
  width: 21rem;
}
.elite li{
  float: left;
  width: 50%;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  color: #000;
  font-weight: 500;
}
.case p{
  font-size: 0.65rem;
  color: #555;
  line-height: 1.3rem;
  width: 21rem;
  margin: 0 auto;
}
.enter-btn{
  display: block;
  padding-top: 0.7rem;
  width: 21rem;
  margin:0 auto;
  text-align: right;
}
.enter-btn button{
  width: 5.6rem;
  height:1.6rem;
  font-size: 0.8rem;
  color: #388bff;
  background-color: #fff;
  border: 1px solid#388bff;
  font-weight: bold;
}
.freshman{
  width: 21rem;
  margin: 0 auto;
  font-size: 0.8rem;
  padding-left: 1rem;
  margin-bottom: 0.5rem;
}
.freshman li{
  font-size: 0.8rem;
  margin-bottom: 0.4rem;
  color: #000;
  font-weight: 500;
}
.chose-domain{
  background-color: white;
  border: white .05rem solid;
  padding: .3rem;
  padding-right: .5rem;
  padding-left: .5rem;
  border-radius: .02rem;
  font-size: .7rem;
}
.chose-domain:hover {
  background-color: #00abff  ;
  color: white ;
}
.sxgc-content{
    height: 100%;
}
</style>
